export default __webpack_public_path__ + "static/media/YOGA-beginning-2.3f15893d.jpg";